<template>
  <button type="button" class="c-button-copy" @click="copyUrl">
    <i class="icon-copy c-button-copy__icon"></i>
    <span v-text="buttonText"></span>
  </button>
</template>

<script>
export default {
  name: 'ComponentButtonCopy',
  props: {
    buttonText: { type: String, default: 'コピー' },
    completedText: { type: String, default: 'コピーしました。' },
    copyText: { type: String, default: '' },
  },
  methods: {
    copyUrl() {
      if (!this.copyText) return
      navigator.clipboard.writeText(this.copyText)
      alert(this.completedText)
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/variables';

.c-button-copy {
  align-items: center;
  background-color: variables.$color-pink;
  border-radius: 3px;
  display: inline-flex;
  font-size: 10px;
  margin-left: 5px;
  padding: 9px 10px;
  vertical-align: middle;

  &__icon {
    font-size: 17px;
    line-height: 1;
    margin-right: 5px;
  }
}
</style>
